import { defineStore, acceptHMRUpdate } from 'pinia'
import useState from './useState'
import useGetters from './useGetters'
import useActions from './useActions'
import useWatchers from './useWatchers'
import { unref } from 'vue'

export const useAuthStore = defineStore('authStore', () => {
  const store = {
    initialState: unref(useState()),
    ...useState(),
    ...useGetters(),
    ...useActions()
  }
  useWatchers(store)
  return store
}, {
  // refreshTimer (a setTimeout id, meaningless across reloads) must never
  // persist — see scheduleRefresh/refresh in useActions.js.
  persist: { pick: ['accessToken', 'accessTokenExpiresAt', 'refreshToken'] }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
